import {
  NumberInput as ChakraNumberInput,
  NumberInputField,
  NumberInputFieldProps,
  FormLabel,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction, useCallback } from 'react';
import { FieldError } from 'react-hook-form';

interface INumberInputProps extends NumberInputFieldProps {
  name: string;
  label?: string;
  error?: FieldError;
  precision?: number;
  isDisabled?: boolean;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, INumberInputProps> =
  (
    { name, label, precision, error = null, isDisabled = false, ...rest },
    ref,
  ) => {
    const handleInputMask = useCallback(
      (e: React.FormEvent<HTMLInputElement>): void => {
        e.currentTarget.value = e.currentTarget.value.replace(/\D/g, '');
      },
      [],
    );

    return (
      <FormControl isInvalid={!!error} isDisabled={isDisabled}>
        {!!label && (
          <FormLabel htmlFor={name} data-disabled={isDisabled ? '' : undefined}>
            {label}
          </FormLabel>
        )}

        <ChakraNumberInput
          precision={precision}
          size="lg"
          isDisabled={isDisabled}
        >
          <NumberInputField
            ref={ref}
            name={name}
            id={name}
            borderColor="gray.300"
            bg="gray.100"
            focusBorderColor="blue.300"
            variant="outline"
            onKeyDown={handleInputMask}
            isDisabled={isDisabled}
            {...rest}
          />
        </ChakraNumberInput>

        {!!error && (
          <FormErrorMessage position="absolute">
            {error.message}
          </FormErrorMessage>
        )}
      </FormControl>
    );
  };

export const NumberInput = forwardRef(InputBase);
